import { Link, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useQuery } from '@tanstack/react-query'
import { ArrowLeft, AlertTriangle } from 'lucide-react'

import { apiClient } from '../services/api'
import LoadingSpinner from '../components/LoadingSpinner'
import InvoiceInspectionPage, { type InvoiceInspection } from './InvoiceInspectionPage'

export default function InvoiceAccessCodePage() {
  const { accessCode } = useParams<{ accessCode: string }>()
  const { t } = useTranslation('invoices')

  const { data, isLoading, error } = useQuery<InvoiceInspection>({
    queryKey: ['invoiceByAccessCode', accessCode],
    queryFn: () => apiClient.get(`/invoices/by-access-code/${accessCode}`),
    enabled: !!accessCode,
    retry: false,
  })

  if (isLoading) {
    return <LoadingSpinner />
  }

  if (error || !data) {
    return (
      <div className="max-w-md mx-auto mt-20 text-center">
        <AlertTriangle className="w-12 h-12 text-amber-500 mx-auto mb-4" />
        <h2 className="text-lg font-semibold text-gray-900 mb-2">
          {t('accessCode.notFound', { code: accessCode })}
        </h2>
        <p className="text-gray-500 mb-6">{t('accessCode.tryAgain')}</p>
        <Link
          to="/"
          className="inline-flex items-center text-primary-600 hover:text-primary-700"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          {t('accessCode.back')}
        </Link>
      </div>
    )
  }

  // Render the inspection page with pre-loaded data
  return <InvoiceInspectionPage data={data} isAccessCodeView />
}
